import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { setPodador } from "../handlers";
import { addYears, format } from "date-fns";

export default function UpdatePodador({ rta, setRta, data }) {
  // const [rta, setRta] = useState({
  //   data: null,
  //   error: null,
  //   params: null,
  //   loading: false,
  // });
  console.log(data);

  const [edit, setEdit] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    resetField,
    setError,
    reset,
    watch,
  } = useForm({
    defaultValues: {
      dni: data.dni,
      nombre: data.nombre,
      telefono: data.telefono,
      info: data.info,
      numero_control: data.numero_control,
      fecha_inicio: data.fecha_inicio,
    },
  });

  const [fechaVencimiento, setFechaVencimiento] = useState();

  useEffect(() => {
    if (watch("fecha_inicio") && watch("fecha_inicio") != "") {
      const fechaIni = new Date(watch("fecha_inicio"));
      const fechaVto = addYears(fechaIni, 2);
      const formattFecha = format(fechaVto, "dd/MM/yyyy");
      const formatFechaForm = format(fechaVto, "yyyy-MM-dd");
      setFechaVencimiento(formattFecha);
      setValue("fecha_vencimiento", formatFechaForm);
    } else {
      setValue("fecha_vencimiento", "");
    }
  }, [watch("fecha_inicio")]);

  const enviar = async (datos) => {
    setPodador(datos, rta, setRta, data.id);
  };

  return (
    <form onSubmit={handleSubmit(enviar)}>
      <fieldset disabled={rta.loading}>
        <label>DNI:</label>
        <input
          defaultValue={data.dni}
          className="form-control"
          {...register("dni", {
            required: "El DNI es requerido",
            min: {
              value: 1000000,
              message: "Minimo 1000000",
            },
            max: {
              value: 99999999,
              message: "Maximo 99999999",
            },
          })}
          disabled={!edit}
          type="number"
        />
        <div className="mt-1" style={{ height: "26px" }}>
          {errors.dni && <span className="text-danger">{errors.dni.message}</span>}
        </div>

        <label>Nombre Completo:</label>
        <input
          defaultValue={data.nombre}
          className="form-control"
          {...register("nombre", {
            required: "El nombre es requerido",
            minLength: {
              value: 3,
              message: "Minimo 3 caracteres",
            },
          })}
          disabled={!edit}
        />
        <div className="mt-1" style={{ height: "26px" }}>
          {errors.nombre && <span className="text-danger">{errors.nombre.message}</span>}
        </div>

        <label>Teléfono:</label>
        <input
          defaultValue={data.telefono}
          className="form-control"
          {...register("telefono")}
          disabled={!edit}
        />
        <div className="mt-1" style={{ height: "26px" }}>
          {errors.telefono && <span className="text-danger">{errors.telefono.message}</span>}
        </div>

        <label>N° de control:</label>
        <input
          defaultValue={data.numero_control}
          className="form-control"
          {...register("numero_control")}
          disabled={!edit}
        />
        <div className="mt-1" style={{ height: "26px" }}>
          {errors.numero_control && (
            <span className="text-danger">{errors.numero_control.message}</span>
          )}
        </div>

        <div className="d-flex align-items-center w-100 gap-4">
          <div>
            <label>Fecha inicio:</label>
            <input
              type="date"
              defaultValue={data.fecha_inicio}
              className="form-control"
              {...register("fecha_inicio")}
              disabled={!edit}
            />
            <div className="mt-1" style={{ height: "26px" }}>
              {errors.fecha_inicio && (
                <span className="text-danger">{errors.fecha_inicio.message}</span>
              )}
            </div>
          </div>
          <div>
            <label>Fecha vencimiento:</label>
            <div
              style={{ height: "38px" }}
              className="d-flex align-items-center px-2 bg-secondary-subtle rounded"
            >
              {watch("fecha_inicio") && fechaVencimiento}
            </div>
            <div className="mt-1" style={{ height: "26px" }}></div>
          </div>
        </div>

        <label>Información adicional:</label>
        <textarea
          defaultValue={data.info}
          className="form-control"
          {...register("info")}
          disabled={!edit}
        />
        <div className="mt-1" style={{ height: "26px" }}>
          {errors.info && <span className="text-danger">{errors.info.message}</span>}
        </div>

        <div className="d-flex justify-content-between">
          {!edit && (
            <button type="button" className="btn btn-sm btn-primary" onClick={() => setEdit(true)}>
              Editar
            </button>
          )}
          {edit && (
            <button
              type="button"
              disabled={rta.loading}
              className="btn btn-sm btn-danger"
              onClick={() => setEdit(false)}
            >
              Cancelar
            </button>
          )}
          {edit && (
            <button type="submit" className="btn btn-sm btn-success d-flex">
              Guardar{" "}
              {rta.loading && (
                <div className="d-flex justify-content-center">
                  <div className="spinner-border text-primary" role="status"></div>
                </div>
              )}
            </button>
          )}
        </div>
      </fieldset>
    </form>
  );
}
